import script from "./GenderInput.vue?vue&type=script&setup=true&lang=js"
export * from "./GenderInput.vue?vue&type=script&setup=true&lang=js"

import "./GenderInput.vue?vue&type=style&index=0&id=4862eafa&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4862eafa"]])

export default __exports__